export const selectUserType = (state) => state.userType;

